import StoreLoyaltyCardServices from '@/services/storeLoyaltyCard'
import EnvironmentUtils from '@/utils/environmentUtils'

async function initFrame (vuexStore, storeId, isManager)
{
    const { cityId } = EnvironmentUtils
    const token = vuexStore.state.user.token

    StoreLoyaltyCardServices.fetchStoreCardConfig(cityId, storeId).then(config  =>
    {
        vuexStore.commit('storeLoyaltyCard/setStoreConfig', config)
    })
    StoreLoyaltyCardServices.fetchStoreRewards(cityId, storeId).then(rewards =>
    {
        vuexStore.commit('storeLoyaltyCard/updateStoreRewards', rewards)
    })
    if (isManager) StoreLoyaltyCardServices.fetchStoreRewardHistory(cityId, storeId, token).then(rewards =>
    {
        vuexStore.commit('storeLoyaltyCard/updateStoreRewardHistory', rewards)
    })
    if (isManager) StoreLoyaltyCardServices.fetchStoreCreditHistory(cityId, storeId, token).then(rewards =>
    {
        vuexStore.commit('storeLoyaltyCard/updateStoreCreditHistory', rewards)
    })
}

export default { initFrame }


// WEBPACK FOOTER //
// ./src/frames/storeLoyaltyCardFrame.js